import { AccordionList } from "@/components/elements/AccordionList";

import { Faq, FaqGroup, FaqGroups } from "../types";
import { QACombo } from "./QACombo";
import { Section } from "./Section";
import styles from "./styles.module.css";
import { Contact, getPreviewQuestions } from "./utils";

export const FAQSections = ({
  preview = false,
  faqGroups,
}: {
  preview?: boolean;
  faqGroups?: FaqGroups;
}) => {
  // Create a react friendly array of sections from the Sanity faqGroups array
  const sections = faqGroups.map((faqGroup: FaqGroup) => {
    // Transform list
    const list = faqGroup.faqs.map((faq: Faq) => {
      const { question, answer } = faq;
      // const portableTextAnswer = <PortableText value={faq.answer}></PortableText>;

      // Make answer a plain text value
      // const answer = toPlainText(portableTextAnswer);

      return {
        question,
        answer,
      };
    });
    const section = {
      header: faqGroup.title,
      list: list, // from above ...
    };
    return section;
  });

  if (preview) {
    const previewQuestions = sections.flatMap(getPreviewQuestions);
    return (
      <AccordionList>
        {previewQuestions.map((item) => (
          <QACombo {...item} key={item.question} />
        ))}
      </AccordionList>
    );
  }

  return (
    <AccordionList>
      {sections.map((section) => (
        <Section {...section} key={section.header} />
      ))}
    </AccordionList>
  );
};

export { Contact, styles };
